export default __webpack_public_path__ + "static/media/designer.46724586.jpg";